import { render, staticRenderFns } from "./datetime_double.vue?vue&type=template&id=0c6d124a"
import script from "./datetime_double.vue?vue&type=script&lang=ts"
export * from "./datetime_double.vue?vue&type=script&lang=ts"
import style0 from "./datetime_double.vue?vue&type=style&index=0&id=0c6d124a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports